import IMenuItem from "@into-discovery/browsewebshared/src/models/header/IMenuItem";
import { IComponentLinkItem, IComponentSubmenuLinkItem, IComponentCampusLinkItem } from "/models/layout/ILayout";

export type MenuItemsConfig = {
  currentLocale: string;
  children?: IMenuItem[];
};

export function getCourseLevelMenuItems(
  config: MenuItemsConfig,
  countryCode: string,
  children: IMenuItem[]
): IMenuItem[] {
  const courses = {
    translationKey: `${countryCode === "US" ? "degrees" : "programmes"}`,
    children
  };

  const courseLevelMenuItems = [courses];

  return courseLevelMenuItems;
}

export function getLegalURLs(config: MenuItemsConfig): IMenuItem[] {
  const privacy = {
    url: `/${config.currentLocale}/legal-and-privacy-policy/into`,
    translationKey: "footer.link.privacy"
  };

  const terms = {
    url: `/${config.currentLocale}/terms`,
    translationKey: "footer.link.terms"
  };

  const cookiesPolicy = {
    url: `/${config.currentLocale}/legal-and-privacy-policy/cookies-policy`,
    translationKey: "footer.link.cookies-policy"
  };

  const governance = {
    url: `${process.env.NEXT_PUBLIC_INTO_STUDY_URL}/${config.currentLocale}/governance`,
    translationKey: "footer.link.governance"
  };

  const accessibility = {
    url: `${process.env.NEXT_PUBLIC_INTO_STUDY_URL}/${config.currentLocale}/accessibility-statement`,
    translationKey: "footer.link.accessibility"
  };

  const modernSlaveryLink = {
    url: `https://media.intostudy.com/image/upload/v1753210184/IUP2-LLP-Modern-Slavery-Statement-YE_Dec_2024_2.pdf`,
    translationKey: "footer.link.modernSlaveryLink",
    target: "_blank"
  };
  const items = [privacy, terms, cookiesPolicy, governance, accessibility, modernSlaveryLink];

  return items;
}

// TODO: Refactor this, use i18n-config.ts
export const localesList = [
  {
    text: "En",
    value: "en"
  },
  {
    text: "中文",
    value: "zh"
  }
];

export type LinkItem = IComponentLinkItem | IComponentSubmenuLinkItem | IComponentCampusLinkItem;

function isComponentLinkItem(link: LinkItem): link is IComponentLinkItem {
  return link.__typename === "ComponentLink";
}

function isComponentSubmenuLinkItem(link: LinkItem): link is IComponentSubmenuLinkItem {
  return link.__typename === "ComponentSubmenuLink";
}

function isComponentCampusLinkItem(link: LinkItem): link is IComponentCampusLinkItem {
  return link.__typename === "ComponentCampusLink";
}

export const getPageURLs = (links: LinkItem[], locale: string): IMenuItem[] => {
  return links.map((link) => {
    if (isComponentLinkItem(link)) {
      return {
        url: `/${locale}${link.urlLink}`,
        text: link.displayName,
        openNewTab: link.openNewTab && link.openNewTab?.length > 0 ? link.openNewTab.includes("Yes") : false
      };
    }

    if (isComponentSubmenuLinkItem(link) || isComponentCampusLinkItem(link)) {
      return {
        text: link.label,
        children: link.linksCollection.links.map((subLink) => ({
          url: isComponentCampusLinkItem(link) ? `${subLink.urlLink}` : `/${locale}${subLink.urlLink}`,
          text: subLink.displayName,
          openNewTab: subLink.openNewTab && subLink.openNewTab?.length > 0 ? subLink.openNewTab.includes("Yes") : false
        })),
        ...(isComponentCampusLinkItem(link) ? { hasCampusLinks: true } : {})
      };
    }

    throw new Error(`Unsupported link: ${link}`);
  });
};
